<template lang="pug">
section#files
  v-container
    v-row(justify-center, style="overflow: hidden")
      v-col
        h2.display-1.font-weight-light.underline.underline--black Upload Files
    v-row
      v-col(v-show="false")
        input(
          ref="files"
          type="file",
          multiple,
          @change="handleFileUploads",
        )
      v-col
        v-btn(
          @click="$refs.files.click()",
          color="geoGray",
          outlined,
          rounded,
          v-bind="{ disabled }",
        ) Upload a File
    v-row
      v-col
        v-list
          template(v-for="(item, index) in filesToUpload")
            app-file-control(
              v-model="filesToUpload[index]",
              uploadMode,
              @removeFile="removeFile(index)",
            )

    .files(v-if="value.id")
      v-row(justify-center, style="overflow: hidden")
        v-col
          h2.display-1.font-weight-light.underline.underline--black Files
      v-row
        v-col
          v-list
            template(v-for="(item, index) in filesEntity")
              app-file-control(
                v-model="filesEntity[index]",
                @downloadFile="downloadfile(item)",
                @deleteFile="deletefile(index)",
              )
</template>

<script>
import axios from 'axios';
import FileDownload from 'js-file-download';

export default {
  name: 'Files',
  props: ['entity', 'value'],
  data: function () {
    return {
      filesToUpload: [],
      filesEntity: []
    }
  },
  computed: {
    disabled() {
      return this.entity.orderStatusId === 3 || this.entity.orderStatusId === 4;
    },
    // DEPRECATED: check it!
    // filesEntity() {
    //   return this.entity.files || [];
    // },
  },
  watch: {
    filesToUpload(value) {
      this.$emit('sendFiles', value);
    },
  },
  methods: {
    handleFileUploads() {
      this.filesToUpload = [...this.filesToUpload, ..._.map(this.$refs.files.files, file => ({ file, fileType: null, fileName: file.name }))];
    },
    removeFile(index) {
      this.filesToUpload.splice(index, 1)
    },
    async deletefile(index) {
      const file = this.filesEntity[index];
      await axios.delete(`file/media/${this.entity.name}/${this.value.id}/${file.uid}`);
      this.filesEntity.splice(index, 1);
    },
    async downloadfile(file) {
      let path_parts = item.localDownloadLink.split('/'); 
      let fileName = path_parts[path_parts.length - 1];
      try {
        const { data} = await axios.get(`file/media/${this.entity.name}/${this.value.id}/${fileName}`, { responseType: 'arraybuffer' });
        FileDownload(data, fileName);
      } catch(e) {
        console.log('ERROR DOWNLOAD ', this.$cleanString(e));
      }
    },
  },
  async mounted () {
    if(this.value.id) ({ data: this.filesEntity } = await axios.get(`file/media/${this.entity.name}/${this.value.id}`));
  }
}
</script>


